import { useEffect } from 'react';
import { EVENT_LISTENERS } from '../../constants/shared/CommonConstants';

const NO_PRINT_CLASS = 'no-print';
const { BEFORE_PRINT, AFTER_PRINT } = EVENT_LISTENERS;

// These indexes are responsible for page breaking in various cases.
export const GRAPH_FIRST_MEASURE_ROW_INDEX = 3;
export const GRAPH_NOT_FIRST_MEASURE_ROW_INDEX = 4;
export const NO_GRAPH_FIRST_MEASURE_ROW_INDEX = 9;
export const NO_GRAPH_NOT_FIRST_MEASURE_ROW_INDEX = 11;

export const getPageBreakingRowIndex = (isGraphExists, isFirstMeasure) => {
    if (isGraphExists && !isFirstMeasure) return GRAPH_NOT_FIRST_MEASURE_ROW_INDEX;
    if (!isGraphExists && isFirstMeasure) return NO_GRAPH_FIRST_MEASURE_ROW_INDEX;
    if (!isGraphExists && !isFirstMeasure) return NO_GRAPH_NOT_FIRST_MEASURE_ROW_INDEX;
    return GRAPH_FIRST_MEASURE_ROW_INDEX;
};

export const isPageShouldBreak = (prevRowIndex, currentRowIndex) =>
    prevRowIndex === currentRowIndex ||
    currentRowIndex - prevRowIndex === NO_GRAPH_NOT_FIRST_MEASURE_ROW_INDEX;

export const printPage = e => {
    e.preventDefault();
    window.print();
};

export default printPage;

export const usePrintPage = noPrintIds => {
    const handleDefaultPrint = event => {
        const classListMethod = event.type === BEFORE_PRINT ? 'add' : 'remove';

        noPrintIds.forEach(id => {
            const elem = document.getElementById(id);
            if (elem) {
                elem.classList[classListMethod](NO_PRINT_CLASS);
            }
        });
    };

    if (noPrintIds) {
        useEffect(() => {
            window.addEventListener(BEFORE_PRINT, handleDefaultPrint);
            window.addEventListener(AFTER_PRINT, handleDefaultPrint);

            return () => {
                window.removeEventListener(BEFORE_PRINT, handleDefaultPrint);
                window.removeEventListener(AFTER_PRINT, handleDefaultPrint);
            };
        });
    }

    return [printPage];
};
